import { service } from '@ember/service';
import type { SafeString } from '@ember/template';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import type { IntlService } from 'ember-intl';
import t from 'ember-intl/helpers/t';
import { concat } from '@ember/helper';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    section: string;
    translationPrefix: string;
  };
}
export default class MiciBaseEditionFormSummaryItemComponent extends Component<Signature> {
  @service declare intl: IntlService;

  get translation(): string | SafeString {
    if (this.intl.exists(this.#answerKey)) {
      return this.intl.t(this.#answerKey, { htmlSafe: true });
    }
    return this.intl.t(this.#answerPath, { value: this.#valueFromChangeset });
  }

  get #answerKey(): string {
    return `${this.#answerPath}.${this.#valueFromChangeset}`;
  }

  get #answerPath(): string {
    return `${this.args.translationPrefix}.${this.args.section}.answers`;
  }

  get #valueFromChangeset(): string {
    return this.args.changeset.get(this.args.section);
  }

  <template>
    <div
      class='flex items-center justify-between gap-2 border-t-2 border-black pt-4'
      data-test-summary-line={{@section}}
    >
      <div class='flex-1' data-test-summary-line-title>{{t
          (concat @translationPrefix '.' @section '.short')
          htmlSafe=true
        }}</div>
      <div
        class='text-purple flex-2 max-w-3/4 text-right font-bold'
        data-test-summary-line-value
      >
        {{this.translation}}
      </div>
    </div>
  </template>
}
